import {ValidLocale} from "./Locales"

export const formatCurrency = (value: number, currency: string, locale: ValidLocale) => {
	return value.toLocaleString(locale, {
		style: "currency",
		currency: currency,
		currencyDisplay: "narrowSymbol",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})
}
